import React, { useState } from "react";
import { PERSONALITY } from "../mock";
import Reveal from "./Reveal";

const Personality = () => {
  const [active, setActive] = useState(0);
  return (
    <section className="relative py-20 lg:py-28 bg-[#0A1220]">
      <div className="max-w-5xl mx-auto px-5 lg:px-8">
        <Reveal className="max-w-2xl mb-12">
          <p className="text-[13px] font-semibold tracking-wide text-[#13D99A] uppercase mb-4">Renn personality</p>
          <h2 className="font-display text-3xl lg:text-5xl font-bold text-[#F5F7FB] leading-[1.08]">
            {PERSONALITY.headline}
          </h2>
          <p className="mt-5 text-lg text-[#8290A8]">{PERSONALITY.copy}</p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {PERSONALITY.options.map((o, i) => {
            const isActive = i === active;
            return (
              <Reveal key={o.name} delay={i * 70}>
                <button
                  onClick={() => setActive(i)}
                  className={`w-full h-full text-left rounded-2xl border p-6 transition-all duration-300 ${
                    isActive
                      ? "border-[#10C98A]/60 bg-[#172031]"
                      : "border-[#29354A] bg-[#121A28] hover:border-[#10C98A]/40"
                  }`}
                >
                  <span className={`inline-block w-2.5 h-2.5 rounded-full mb-4 ${isActive ? "bg-[#13D99A]" : "bg-[#29354A]"}`} />
                  <h3 className="font-display text-lg font-bold text-[#F5F7FB] mb-2">{o.name}</h3>
                  <p className="text-sm text-[#8290A8]">{o.desc}</p>
                </button>
              </Reveal>
            );
          })}
        </div>
        <Reveal>
          <p className="mt-8 text-sm text-[#8290A8] max-w-3xl">{PERSONALITY.note}</p>
        </Reveal>
      </div>
    </section>
  );
};

export default Personality;
